<p-confirmDialog key="add" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Grid-->
<div class="MainGrid2Col">
	<!--INSERT CUSTOM POPUP FIELDS-->

	<label># of Activations:</label>
	<input [disabled]="Processing == true" class="form-control" type="number" min="1" [(ngModel)]="TotalCount" />

	<label>Issue Date:</label>
	<p-calendar
		[disabled]="Processing == true"
		showIcon="true"
		showButtonBar="true"
		[(ngModel)]="IssueDate"
		name="IssueDate"
		(onShow)="IssueGrowCell($event)"
		(onClose)="IssueShrinkCell($event)"
	></p-calendar>

	<label>Expires:</label>
	<input [disabled]="Processing == true" class="form-control CHK" type="checkbox" [(ngModel)]="Expires" />

	<label *ngIf="Expires == true">Expire Date:</label>
	<p-calendar
		*ngIf="Expires == true"
		[disabled]="Processing == true"
		showIcon="true"
		showButtonBar="true"
		[(ngModel)]="ExpireDate"
		name="ExpireDate"
		(onShow)="ExpireGrowCell($event)"
		(onClose)="ExpireShrinkCell($event)"
	></p-calendar>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="Processing == true" class="btn btn-primary" (click)="onAdd()">Add</button>
	<button [disabled]="Processing == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
